import { useEffect, useState } from 'react'
import actorsApi from '../../client/actors-api'
import { MediaGridItem } from '../../types/Media'
import MediaGridPage from '../../areas/layout/media-grid-page'

const ActorsPage = () => {
  const [items, setItems] = useState<MediaGridItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)

  const fetchActors = async (p: number) => {
    return actorsApi.getPopular(p)
  }

  const loadPage = async (p: number) => {
    try {
      setLoading(true)
      const res = await fetchActors(p)
      const data = res.data
      if (!data || !data.results || data.results.length === 0) {
        setHasMore(false)
        return
      }

      setItems((prev) => [
        ...prev,
        ...data.results.map((actor: any) => ({
          id: actor.id,
          type: 'person' as const,
          title: actor.name,
          rating: actor.popularity,
          posterUrl: actor.profileUrl,
          genres: actor.knownFor,
        })),
      ])

      setHasMore(p < data.totalPages)
    } catch {
      setError('Failed to load actors')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    setItems([])
    setPage(1)
    setHasMore(true)
    loadPage(1)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleLoadMore = () => {
    if (loading || !hasMore) return
    const next = page + 1
    setPage(next)
    loadPage(next)
  }

  return (
    <MediaGridPage
      title='Actors'
      subtitle='Popular actors'
      items={items}
      loading={loading}
      error={error}
      hasMore={hasMore}
      onLoadMore={handleLoadMore}
    />
  )
}

export default ActorsPage
